export default "__VITE_ASSET__Bhz7gjw$__"